import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class CompensationFormat extends Enum {
  static PERCENT = {
    key: 'percent',
    get value() {
      return Lang.t('liability.297e9702-0394-4d30-b6ab-24ca9a41aef6');
    }
  };

  static FIXED = {
    key: 'fixed',
    get value() {
      return Lang.t('liability.20b64267-ef45-4eb1-a0c2-fba181f2223b');
    }
  };
}
